console.debug(`VUE_APP_ISCACHE: ${process.env.VUE_APP_ISCACHE}`)
// const isCache = process.env.VUE_APP_ISCACHE === 'true' ? true : false
const BASEURL_DOMAIN = process.env.VUE_APP_APIURL_WORLDCUP
const BASEURL_API = process.env.VUE_APP_APIURL_API

// marathon 接口 start ---------

function computedBaseUrl(baseApi) {
  // 不同开发环境，不同接口根目录，导致域名不同
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_API === 'development'
  ) {
    // 本地开发
    return baseApi
  }
  return computedHost(baseApi)
}

function computedHost(baseApi) {
  let baseUrl = ''
  if (baseApi.indexOf('/api') === 0) {
    baseUrl = BASEURL_API
  } else if (baseApi.indexOf('/127.0.0.1') > 0) {
    baseUrl = ''
  } else if (baseApi.indexOf('/766a2c82.cpolar.top') > 0) {
    baseUrl = ''
  } else {
    baseUrl = BASEURL_DOMAIN
  }
  console.debug('computedHost:', baseUrl, baseApi)
  return baseUrl + baseApi
}

// 首页 用户登录 接口
export const https_user_login = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/user/login`), params)
}

// 首页 用户退出 接口
export const https_user_logout = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/user/logout`))
}

// 首页 获取群组列表信息 接口
export const https_manage_getGroupData = (baseUrl, axios) => {
  return axios.post(computedBaseUrl(`${baseUrl}/competition/getGroupData`))
}

// 登录状态下获取用户信息
export const http_userLoginfo = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/user/loginfo`))
}

// 首页 赛事类别数据 接口
export const https_home_getAllCompet = (baseUrl, axios) => {
  return axios.get(
    computedBaseUrl(`${baseUrl}/competition/getCompetitionCategory`)
  )
}

// 首页 获取赛事列表 接口
export const https_home_getCompetitionByCategory = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/competition/getCompetitionByCategory`),
    params
  )
}

// 获取上传oss图片时需要的id、token等信息
export const https_getOssUploadInfor = (baseUrl, axios) => {
  return axios.get(computedBaseUrl(`${baseUrl}/common/stskey`))
}

// 播出单接口 start -----------------------------------

// 通过某个小项ID  获取 日期|比赛信息  的接口
export const https_getOneEventMatchList = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/sc/schedule/broadcast/${params.sid}/${params.sportsId}/${params.eventId}`
    )
  )
}

// 播出单-查找模板类型 接口
export const https_package_getTemplateTypes = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/getTemplateTypes`),
    params
  )
}

// 播出单-获取演播室列表 接口
export const https_package_getPackageRoom = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/package/getPackageInfos?groupId=${params.groupId}`
    )
  )
}

// 播出单-获取公共播单数据项和数据 接口
export const https_package_getDataItemByGroup = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/getDataItemByGroup`),
    params
  )
}

// 播出单-获取某个包装的数据项 接口
export const https_package_getPackageItemInfos = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/package/getPackageItemInfos`),
    params
  )
}

// 比赛详情相关-第一步：根据类型查找分析项
export const https_package_findAnalysisItem = (baseUrl, axios, params) => {
  // templateType:主题类型，1：比赛-赛前；2：比赛-阵容；3：比赛-数据分析

  let pathUrl = ''
  if (params.eid + '') {
    pathUrl = `${baseUrl}/workbench/findAnalysisItem/${params.templateType}/${params.cid}/${params.sid}/${params.did}/${params.eid}/${params.pid}/${params.mid}`
  } else {
    pathUrl = `${baseUrl}/workbench/findAnalysisItem/${params.templateType}/${params.cid}/${params.sid}/${params.mid}`
  }
  console.debug('https_package_findAnalysisItem:', params, pathUrl)
  return axios.get(computedBaseUrl(pathUrl))
}

export const https_package_getMoreDataByAnalysisID = (
  baseUrl,
  axios,
  params
) => {
  // 比赛详情-第二步根据统计项i的和下拉框选择值查找数据
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/getMoreDataByAnalysisID`),
    params
  )
}

// 分享，即生成数据项 接口
export const https_package_createDataItem = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/createDataItem`),
    params
  )
}

// 切换主题选择框时访问的接口
export const https_package_selectApi = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}${params}`))
}

// 播出单-加入/删除公共播单 接口
export const https_package_isAddPublicBroadcastItem = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/isAddPublicBroadcastItem`),
    params
  )
}

// 播出单-修改数据项名称 接口
export const https_package_changeDataItemName = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/changeDataItemName`),
    params
  )
}

// 播出单-媒体云 获取参数配置类型 接口
export const https_package_getConfigurationParam = (baseUrl, axios, params) => {
  return axios.get(computedBaseUrl(`${baseUrl}/package/getConfigurationParam`))
}

// 播出单-媒体云 编辑参数配置 接口
export const https_package_editConfigurationParam = (
  baseUrl,
  axios,
  params
) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/package/editConfigurationParam?packageId=${params.packageId}&videoResolution=${params.videoResolution}&videoFormat=${params.videoFormat}&videoPlateType=${params.videoPlateType}&pictureResolution=${params.pictureResolution}&pictureFormat=${params.pictureFormat}&picturePlateType=${params.picturePlateType}`
    )
  )
}

// 播出单-【合成】按钮 接口
export const https_package_previewPicOrVideo = (
  baseUrl,
  axios,
  params,
  options
) => {
  let newParams = JSON.parse(JSON.stringify(params))
  if (newParams.type) {
    delete newParams.type
  }
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/${params.type}`),
    newParams,
    options
  )
}

// 播出单- 单个【推送】按钮 接口
export const https_package_pushMaterialsItem = (
  baseUrl,
  axios,
  params,
  options
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/workbench/pushMaterialOne`),
    params,
    options
  )
}

// 播出单-获取推送某个播出单全部主题数据（大洋的） 接口
export const https_package_pushBroadcastDaYang = (baseUrl, axios, params) => {
  console.debug('https_package_pushBroadcastDaYang:', params)
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/transpondBroadcast`),
    params,
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  )
}

// 播出单-获取推送单个主题数据（大洋的） 接口
export const https_package_pushItemThemeDaYang = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/transpondDataItem`),
    params,
    {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    }
  )
}

// 播出单-通过内网推送给大洋
export const https_package_inSidePushDataDaYang = (
  baseUrl,
  axios,
  params,
  type
) => {
  let otherUrl = ''
  if (type === 'themeItem') {
    // 推送单个主题
    otherUrl = '/pushData/dataItemData'
  } else {
    // 推送某个播出单下所有主题
    otherUrl = '/pushData/broadcastData'
  }
  if (params.url) {
    params.url = computedHost(params.url)
  }
  return axios.post(computedBaseUrl(`${baseUrl}${otherUrl}`), params)
}

// 播出单接口 end -----------------------------------

// 数据包装接口 start -----------------------------------

// 数据包装- 查找赛事赛季日期，前后各推一个月 接口
export const https_media_getStartEndDate = (baseUrl, axios, params) => {
  return axios.get(
    computedBaseUrl(
      `${baseUrl}/media/genSeasonDate/${params.cid}/${params.sid}`
    )
  )
}

// 数据包装- 获取某个用户某天生成的数据主题 接口
export const https_media_getUserThemeDataList = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/media/getUserDataItemInfos`),
    params
  )
}

// 数据包装- 获取刷新状态 接口
export const https_media_getRefreshStatus = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/media/getRefreshStatus`),
    params
  )
}

// 数据包装接口 end -----------------------------------

//autoExportPng.vue  自动下载图片 start --------------------------

export const https_package_dataByDataItemID = (baseUrl, axios, params) => {
  // 获取自动生成png图片的数据
  return axios.post(`${baseUrl}/workbench/getDataItemDataById`, params, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      eflag: 'b1e0694f5c9f0b424930d52c1b3e5622',
    },
  })
}

export const https_package_uploadImage = (baseUrl, axios, params) => {
  // 上传自动生成png图片给后台
  return axios.post(`${baseUrl}/image/uploadImage`, params, {
    headers: {
      'content-type': 'application/json',
      eflag: 'b1e0694f5c9f0b424930d52c1b3e5622',
    },
  })
}

// 自动下载图片 end --------------------------

// 播出单 start --------------------------

// 播出单-获取播出单list 接口
export const https_broadcast_postBroadcasts = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/getBroadcasts`),
    params
  )
}

// 播出单-获取单个播出单下面的所有主题数据 接口
export const https_broadcast_postPlayerItemToThemeList = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/getBroadcastDataItem`),
    params
  )
}

// 播出单-创建播出单 接口
export const https_broadcast_postCreateBroadcast = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/createBroadcast`),
    params
  )
}

// 播出单-删除播出单 接口
export const https_broadcast_postRemoveBroadcast = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/deleteBroadcast`),
    params
  )
}

// 播出单-修改播出单信息 接口
export const https_broadcast_postEditBroadcast = (baseUrl, axios, params) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/changeBroadcast`),
    params
  )
}

// 播出单-删除单个主题 | 批量 删除多个主题 接口
export const https_broadcast_postClearBroadcastItems = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/clearBroadcastItems`),
    params
  )
}

// 播出单-获取组用户的默认配置项 接口
export const https_broadcast_postBroadcastShareState = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/getBroadcastShareState`),
    params
  )
}

// 播出单-保存组用户的默认配置项 接口
export const https_broadcast_postSaveBroadcastShareState = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(
    computedBaseUrl(`${baseUrl}/broadcast/setBroadcastShareState`),
    params
  )
}

// 播出单-生成播单【在线包|安全岛】 接口
export const https_package_sendPackageItemInfos = (
  baseUrl,
  axios,
  params,
  type
) => {
  let otherUrl = ''
  if (type === 'safetyUser') {
    otherUrl = '/broadcast/produceBroPackage'
  } else {
    params.url = computedHost(params.url)
    console.debug(params)
    otherUrl = '/cdvData/createPlayCard'
  }
  return axios.post(computedBaseUrl(`${baseUrl}${otherUrl}`), params)
}

// 播出单-下载单个主题数据【在线包|安全岛】 接口
export const https_package_downItemThemeData = (
  baseUrl,
  axios,
  params,
  type
) => {
  let otherUrl = ''
  if (type === 'safetyUser') {
    otherUrl = '/broadcast/loadDataItem'
  } else {
    params.url = computedHost(params.url)
    otherUrl = '/cdvData/updateDataItem'
  }
  return axios.post(computedBaseUrl(`${baseUrl}${otherUrl}`), params)
}

// 播出单-下载某个播出单所有数据【在线包|安全岛】 接口
export const https_package_downItemPlayerItemData = (
  baseUrl,
  axios,
  params,
  type
) => {
  let otherUrl = ''
  if (type === 'safetyUser') {
    otherUrl = '/broadcast/loadBroadcastData'
  } else {
    params.url = computedHost(params.url)
    otherUrl = '/cdvData/updateAllData'
  }
  return axios.post(computedBaseUrl(`${baseUrl}${otherUrl}`), params)
}

// 播出单 end --------------------------

// 节目单 start --------------------------

// 节目单-获取频道列表 接口
export const https_programList_postChannelList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/getChannel`), params)
}

// 节目单-获取节目列表 接口
export const https_programList_postProgramList = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/getProgram`), params)
}

// 节目单-添加节目 接口
export const https_programList_postAddSingleProgram = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/insertProgram`), params)
}

// 节目单-修改节目 接口
export const https_programList_postUpdateProgram = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/updateProgram`), params)
}

// 节目单-删除节目 接口
export const https_programList_postDeleteProgram = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/deleteProgram`), params)
}

// 节目单-删除当天所有节目 接口
export const https_programList_postDeleteDateAllProgram = (
  baseUrl,
  axios,
  params
) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/deleteInBatches`), params)
}

// 节目单-批量导入节目单 接口
export const https_programList_postImportExcel = (baseUrl, axios, params) => {
  return axios.post(computedBaseUrl(`${baseUrl}/work/importExcel`), params, {
    headers: {
      'content-type': false,
      // 问题：如果设置了全局的content-type,会发现上传接口设置multipart/form-data是不起作用的，因为没有Boundary，所以上传必定失败，服务器500。然后尝试手动添加Boundary，这次错误变400了。其实multipart/form-data不需要指定，浏览器会根据文件类型自动添加content-type并加上Boundary
      // 第一种方法：这样浏览器会自己根据参数FormData去添加头部和边界；但是这种方式在有些请求库中不生效，据我所知jquery，axios可以，umi不行，原因是umi-request依赖的一个插件库导致的；当然如果不行可能是拦截器二次处理导致的。
      // 第二种方法就是再创建一个请求实例不指定请求头content-type。
    },
  })
}

// 节目单 end --------------------------
